'use strict';

var _toConsumableArray = require("/home/jfontirroig/pact/dappcrosscheck/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var range = function range(n) {
  return _toConsumableArray(Array(n).keys());
};

function makeConverter(TYPE_BYTE) {
  function decode(keyVal) {
    if (keyVal.key[0] !== TYPE_BYTE) {
      throw new Error('Decode Error: could not decode bip32Derivation with key 0x' + keyVal.key.toString('hex'));
    }

    if (!(keyVal.key.length === 34 || keyVal.key.length === 66) || ![2, 3, 4].includes(keyVal.key[1])) {
      throw new Error('Decode Error: bip32Derivation has invalid pubkey in key 0x' + keyVal.key.toString('hex'));
    }

    if (keyVal.value.length / 4 % 1 !== 0) {
      throw new Error('Decode Error: Input BIP32_DERIVATION value length should be multiple of 4');
    }

    var pubkey = keyVal.key.slice(1);
    var data = {
      masterFingerprint: keyVal.value.slice(0, 4),
      pubkey: pubkey,
      path: 'm'
    };
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = range(keyVal.value.length / 4 - 1)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var i = _step.value;
        var val = keyVal.value.readUInt32LE(i * 4 + 4);
        var isHard = !!(val & 0x80000000);
        var idx = val & 0x7fffffff;
        data.path += '/' + idx.toString(10) + (isHard ? "'" : '');
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    return data;
  }

  function encode(data) {
    var head = Buffer.from([TYPE_BYTE]);
    var key = Buffer.concat([head, data.pubkey]);
    var splitPath = data.path.split('/');
    var value = Buffer.allocUnsafe(splitPath.length * 4);
    data.masterFingerprint.copy(value, 0);
    var offset = 4;
    splitPath.slice(1).forEach(function (level) {
      var isHard = level.slice(-1) === "'";
      var num = 0x7fffffff & parseInt(isHard ? level.slice(0, -1) : level, 10);
      if (isHard) num += 0x80000000;
      value.writeUInt32LE(num, offset);
      offset += 4;
    });
    return {
      key: key,
      value: value
    };
  }

  var expected = '{ masterFingerprint: Buffer; pubkey: Buffer; path: string; }';

  function check(data) {
    return Buffer.isBuffer(data.pubkey) && Buffer.isBuffer(data.masterFingerprint) && typeof data.path === 'string' && [33, 65].includes(data.pubkey.length) && [2, 3, 4].includes(data.pubkey[0]) && data.masterFingerprint.length === 4;
  }

  function canAddToArray(array, item, dupeSet) {
    var dupeString = item.pubkey.toString('hex');
    if (dupeSet.has(dupeString)) return false;
    dupeSet.add(dupeString);
    return array.filter(function (v) {
      return v.pubkey.equals(item.pubkey);
    }).length === 0;
  }

  return {
    decode: decode,
    encode: encode,
    check: check,
    expected: expected,
    canAddToArray: canAddToArray
  };
}

exports.makeConverter = makeConverter;